import { PerfectMatchSteps } from './types';

export const Steps = {
  Intro: 'intro' as PerfectMatchSteps,
  Type: 'type' as PerfectMatchSteps,
  WindowStyle: 'windowStyle' as PerfectMatchSteps,
  WindowLocation: 'windowLocation' as PerfectMatchSteps,
  WindowCoastal: 'windowCoastal' as PerfectMatchSteps,
  WindowProjectType: 'windowProjectType' as PerfectMatchSteps,
  WindowPreferences: 'windowPreferences' as PerfectMatchSteps,
  WindowResults: 'windowResults' as PerfectMatchSteps,
  DoorStyle: 'doorStyle' as PerfectMatchSteps,
  DoorOperation: 'doorOperation' as PerfectMatchSteps,
  DoorSizeAndPanels: 'doorSizeAndPanels' as PerfectMatchSteps,
  DoorPanelStyle: 'doorPanelStyle' as PerfectMatchSteps,
  DoorLocation: 'doorLocation' as PerfectMatchSteps,
  DoorCoastal: 'doorCoastal' as PerfectMatchSteps,
  DoorProjectType: 'doorProjectType' as PerfectMatchSteps,
  DoorPreferences: 'doorPreferences' as PerfectMatchSteps,
  DoorResults: 'doorResults' as PerfectMatchSteps,
};
